import { render } from "./CardsTable.vue?vue&type=template&id=6bc6df0d&scoped=true"
import script from "./CardsTable.vue?vue&type=script&lang=js"
export * from "./CardsTable.vue?vue&type=script&lang=js"

import "./CardsTable.vue?vue&type=style&index=0&id=6bc6df0d&scoped=true&lang=css"
import "./CardsTable.vue?vue&type=style&index=1&id=6bc6df0d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc6df0d"]])

export default __exports__